import { SearchType } from 'app/constants';

export enum ChangeTrigger {
    input = 'input',
    select = 'select'
}

export type SearchFieldValue = {
    type: SearchType;
    query: string;
    software: string;
    version: string;
};

export type SearchFieldErrors = {
    software?: string;
    version?: string;
};

export interface SearchFieldRef {
    submit: () => void;
}
